var map = {
	"./calibration/akustik.svg": "f48e",
	"./calibration/aliran_dan_volume_fluida.svg": "a784",
	"./calibration/analytical_testing_instrument.svg": "6687",
	"./calibration/densitas.svg": "3595",
	"./calibration/dimensi.svg": "066d",
	"./calibration/dimensi_dan_panjang.svg": "c28a",
	"./calibration/fotometry_dan_radiometry.svg": "9f7b",
	"./calibration/gaya.svg": "7a01",
	"./calibration/kekerasan.svg": "a537",
	"./calibration/kelistrikan.svg": "0540",
	"./calibration/lain_lain.svg": "0fcb",
	"./calibration/massa.svg": "a7a9",
	"./calibration/optik.svg": "ec97",
	"./calibration/radiasi_pengion.svg": "d304",
	"./calibration/suhu_dan_kelembaban.svg": "e96b",
	"./calibration/tekanan.svg": "949a",
	"./calibration/torsi.svg": "2c0c",
	"./calibration/vibrasi.svg": "b892",
	"./calibration/volumetrik.svg": "4c22",
	"./farmasi_dan_kimia.svg": "297f",
	"./kelistrikan_dan_elektronika.svg": "654c",
	"./kesehatan.svg": "d54c",
	"./konstruksi.svg": "04b5",
	"./lain_lain.svg": "a6be",
	"./lingkungan_dan_biologi.svg": "05ff",
	"./listrik.svg": "d86ba",
	"./manufacture_dan_otomotif.svg": "2642",
	"./pertambangan_dan_mineral.svg": "cf5a"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "8098";